/**
 * Email Normalization Utility
 * 
 * Ensures all emails are stored and processed in lowercase to prevent
 * case sensitivity issues across the application.
 */

/**
 * Normalizes an email address to lowercase
 * @param email - The email address to normalize
 * @returns The normalized (lowercase) email address
 */
export const normalizeEmail = (email: string): string => {
  return email.trim().toLowerCase();
};

/**
 * Validates and normalizes an email address
 * @param email - The email address to validate and normalize
 * @returns Object with isValid flag and normalized email
 */
export const validateAndNormalizeEmail = (email: string): { 
  isValid: boolean; 
  normalizedEmail: string;
  error?: string;
} => {
  const trimmed = email.trim();
  
  if (!trimmed) {
    return {
      isValid: false,
      normalizedEmail: '',
      error: 'Email is required'
    };
  }
  
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(trimmed)) {
    return {
      isValid: false,
      normalizedEmail: trimmed.toLowerCase(),
      error: 'Please enter a valid email address'
    };
  }
  
  return {
    isValid: true,
    normalizedEmail: trimmed.toLowerCase()
  };
};
